import { render } from "./ReactivationDialog.vue?vue&type=template&id=3146ff52"
import script from "./ReactivationDialog.vue?vue&type=script&lang=js"
export * from "./ReactivationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__